import axios from "axios"
import { Message } from "element-ui"
import store from "../store"
import { getToken } from "@/utils/auth"
import qs from "qs"

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // timeout: 15000
  paramsSerializer: params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
      encode: false
    })
  }
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers["Authorization"] = "bearer " + getToken()
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (parseInt(response.status) >= 100 && parseInt(response.status) < 400) {
      return response.data
    }
  },
  error => {
    if (error.response.status === 401) {
      Message({
        message: error.response.data.error,
        type: error.response.data.status ? error.response.data.status : "error",
        duration: 5 * 1000
      })
    } else if (error.response.status === 404) {
      Message({
        message: error.response.data.message
          ? error.response.data.message
          : "Element introuvable",
        type: error.response.data.status ? error.response.data.status : "error",
        duration: 5 * 1000
      })
    } else if (error.response.status === 404) {
      Message({
        message: error.response.data.message
          ? error.response.data.message
          : "Element introuvable",
        type: error.response.data.status ? error.response.data.status : "error",
        duration: 5 * 1000
      })
    } else if (error.response.status === 422) {
      let errors = error.response.data.errors
      const parag = document.createElement("p")
      if (errors) {
        for (const [, messages] of Object.entries(errors)) {
          const ul = document.createElement("ul")
          // ul.appendChild(document.createTextNode(field))
          messages.forEach(msg => {
            const li = document.createElement("li")
            li.appendChild(document.createTextNode(msg))
            ul.appendChild(li)
          })
          parag.appendChild(ul)
        }
      } else {
        const { message } = error.response.data
        const ul = document.createElement("ul")
        // ul.appendChild(document.createTextNode(field))
        const li = document.createElement("li")
        li.appendChild(document.createTextNode(message))
        ul.appendChild(li)
        parag.appendChild(ul)
      }

      Message({
        dangerouslyUseHTMLString: true,
        message: parag.innerHTML,
        type: "error",
        duration: 5 * 1000
      })
    } else if (error.response.status === 500) {
      let errorMsg =
        "Oops! Une erreur serveur s'est produite, veuillez informer un administrateur. (Code: 500)"
      if (error.response.data.message) {
        console.error(error.response.data.message)
      }
      Message({
        message: errorMsg,
        type: error.response.data.status ? error.response.data.status : "error",
        duration: 5 * 1000
      })
    } else {
      Message({
        // prettier-ignore
        message: `Oops! Une erreur s'est produite, veuillez informer un administrateur. (Code: ${error.response.status})`,
        type: "error",
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
